export default __webpack_public_path__ + "static/media/fishdom.0b7922c7.webp";